<template>
	<SOSlotBase
		:bg-white="true"
	>
		<template v-slot:title-bar>
			<SOTitleBar
				:type="'back'"
				:page-title="'Transaksi menggunakan QRIS'"
				@back="back"
			/>
		</template>
		<template v-slot:content>
			<div class="p-x-20 p-y-16 f-regular f-14 f-c-black text-justify">
				<div class="img-banner m-d-20"></div>

				<p class="f-bold f-16">Terima Seluruh Pembayaran e-wallet dengan Satu QRIS</p>

				<p>Kini anda bisa lebih mudah menerima pembayaran melalui e-wallet di outlet laundry anda.
					Hanya cukup SCAN SATU QRIS bisa terima pembayaran dari e-wallet manapun.</p>

				<center>
					<img style="width: 100%; max-width: 400px;" src="@/assets/img/banner/SK.jpg" class="img-fluid" alt="">
				</center>

				<p>Untuk meningkatkan keefektifan dalam proses transaksi pembayaran menggunakan QR Code di Outlet
					Laundry anda,
					smartlink meluncurkan fitur pembayaran melalui QRIS dengan keuntungan sebagai berikut :</p>

				<ol style="padding-inline-start: 16px">
					<li>Mempercepat transaksi, cukup pindai kode QR transaksi bisa langsung selesai</li>
					<li>Mempermudah owner, tidak perlu repot mendaftar sebagai merchant di satu per satu layanan
						pembayaran digital.
					</li>
					<li>Lebih Handal, karena riwayat transaksi dapat dicek secara berkala oleh owner. Selain itu, semua
						transaksi terproses dan terekam secara otomatis
					</li>
					<li>Lebih aman ketika melayani pelanggan, tidak perlu melakukan kontak fisik. sehingga bisa
						membatasi kontak langsung antara karyawan dan pelanggan. Jadi Lebih aman dari penularan virus
					</li>
				</ol>

				<p>Tunggu apalagi? nikmati kemudahan Terima pembayaran Seluruh Pembayaran e-wallet dengan Satu QRIS di
					aplikasi kasir smartlink.</p>

				<p>Informasi lebih lanjut, hubungi whatsapp customer service di kontak berikut: <a
					href="https://wa.me/6285234494494" target="_blank">0852 3449 4494</a></p>

				<p class="attention p-x-8 p-y-8 rounded">Catatan: Perlu dilakukan update Power Merchant untuk melakukan pencairan dana yang masuk melalui
					pembayaran QRIS.
<br/>
- Penarikan saldo diatas Rp.5.000.000 tidak dikenakan biaya admin <b>GRATIS</b>
<br/>
- Penarikan dibawah Rp.5.000.000 dikenakan biaya admin Rp. 5.500
</p>
			</div>
		</template>
	</SOSlotBase>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";

export default {
	name: "AnnouncementPage",
	components: {
		SOSlotBase,
		SOTitleBar,
	},
	methods: {
		back() {
			this.$router.back()
		}
	}
}
</script>

<style scoped>
.img-banner {
	background-image: url("../assets/img/banner/banner_qris.jpg");
	height: 120px;
	width: 100%;
	background-position: center;
	background-size: cover;
	border-radius: 4px;
}
.attention {
	background-color: #FFF9E4;
	color: #C29500;
}
</style>